import { render, staticRenderFns } from "./Button-1.vue?vue&type=template&id=6606c884&scoped=true&"
import script from "./Button-1.vue?vue&type=script&lang=js&"
export * from "./Button-1.vue?vue&type=script&lang=js&"
import style0 from "./Button-1.vue?vue&type=style&index=0&id=6606c884&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606c884",
  null
  
)

export default component.exports